import { put, call } from "redux-saga/effects";
import { VisaCareI140CaseAPI } from "../../utils/api/VisaCareI140CaseAPI";
import {   SAVE_I140FORMS_SUCCESS,SAVE_I140FORMS_FAILED ,  
    UPDATE_I140FORMS_SUCCESS,UPDATE_I140FORMS_FAILED, 
    GET_I140FORMS_SUCCESS,GET_I140FORMS_FAILED ,     
    SAVEPDF_I140FORMS_FAILED , SAVEPDF_I140FORMS_SUCCESS
} from "../actions/VisaCareI140Case";
 
export function* i140formsCreate(request: any) {
  
    try {
           const result=yield call(VisaCareI140CaseAPI.i140formsCreate, request.input);
         yield put({ 
            type: SAVE_I140FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I140FORMS_FAILED, payload: e.message });
    }
}

export function* i140formsUpdate(request: any) {
   
    try {
           const result=yield call(VisaCareI140CaseAPI.i140formsUpdate, request.input);
         yield put({ 
            type: UPDATE_I140FORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I140FORMS_FAILED, payload: e.message });
    }
}
export function*getI140formsDetails (request:any) {
    try {
      
        const { data } = yield call(VisaCareI140CaseAPI.getI140formsDetails,request);
    
      yield put({
          type: GET_I140FORMS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_I140FORMS_FAILED, payload: e.message });
    }
  }


   
  export function* i140FormPdfSubmit(request: any) {
 
    try {
           const { data }=yield call(VisaCareI140CaseAPI.i140FormPdfSubmit, request);
         yield put({ 
            type: SAVEPDF_I140FORMS_SUCCESS,     
            payload: data
            
        });
        
    } catch (e) {
        yield put({ type: SAVEPDF_I140FORMS_FAILED, payload: e.message });
    }

    
    } 